import { render, staticRenderFns } from "./tour-price.vue?vue&type=template&id=08b7f5f4&"
import script from "./tour-price.vue?vue&type=script&lang=js&"
export * from "./tour-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tour-price.vue"
export default component.exports